import { z } from "zod";
export const BatchPortfolioPrivacySafeguardsV1Schema = z
    .object({
    schemaVersion: z.literal("batch-portfolio-privacy-safeguards.v1.0"),
    maxUrlsPerBatch: z.number().int().positive(),
    rateLimitPerHour: z.number().int().positive(),
    redactQueryStrings: z.literal(true),
    redactEmailInPath: z.literal(true),
    clientSafeSubmittedUrlOnly: z.literal(true),
})
    .strict();
export const BATCH_PORTFOLIO_PRIVACY_SAFEGUARDS = BatchPortfolioPrivacySafeguardsV1Schema.parse({
    schemaVersion: "batch-portfolio-privacy-safeguards.v1.0",
    maxUrlsPerBatch: 50,
    rateLimitPerHour: 10,
    redactQueryStrings: true,
    redactEmailInPath: true,
    clientSafeSubmittedUrlOnly: true,
});
const EMAIL_IN_PATH = /\/[^/]*@[^/]+/i;
/** Redact portfolio PII from URLs before client-safe batch views (GR-008). */
export function redactPortfolioSubmittedUrl(url) {
    try {
        const parsed = new URL(url);
        parsed.search = "";
        parsed.hash = "";
        let path = parsed.pathname.replace(EMAIL_IN_PATH, "/[redacted]");
        if (path.length > 120)
            path = `${path.slice(0, 117)}...`;
        parsed.pathname = path;
        return parsed.toString();
    }
    catch {
        return "[invalid-url-redacted]";
    }
}
export function assertBatchPrivacyClientSafeUrl(url) {
    if (EMAIL_IN_PATH.test(url)) {
        throw new Error("batch_portfolio_pii_leak");
    }
    if (url.includes("?") || url.includes("#")) {
        throw new Error("batch_portfolio_query_leak");
    }
}
//# sourceMappingURL=portfolio-privacy.js.map